import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
	Box,
	Button,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { CodeListFileDto } from "Infrastructure/Api/Api";
import { useState } from "react";
import {
	CODELIST_FILES_QUERY_KEY,
	useCodeListFilesQuery,
} from "../../Api/Queries/useCodeListFilesQuery";
import { FileList } from "./FileList";
import { FileUploadDialog } from "./FileUploadDialog";
import { FileVersionHistory } from "./FileVersionHistory";
import { FolderTree } from "./FolderTree";

export const FilesTab: React.FunctionComponent = () => {
	const [selectedFolder, setSelectedFolder] = useState<string | null>(
		"codelists",
	);
	const [versionHistoryFile, setVersionHistoryFile] =
		useState<CodeListFileDto | null>(null);
	const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

	const queryClient = useQueryClient();
	const { data, isLoading } = useCodeListFilesQuery();

	const files = data?.status === 200 ? data.data : [];

	const handleRefresh = () => {
		queryClient.invalidateQueries({ queryKey: [CODELIST_FILES_QUERY_KEY] });
	};

	return (
		<Box sx={{ height: "calc(100vh - 250px)", minHeight: 400 }}>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				sx={{ px: 2, py: 0.75, borderBottom: 1, borderColor: "divider" }}
			>
				<Stack direction="row" alignItems="center" spacing={0.75}>
					<Typography variant="subtitle1">
						{selectedFolder || "codelists"}
					</Typography>
				</Stack>
				<Stack direction="row" spacing={1} alignItems="center">
					<Tooltip title="Obnovit">
						<IconButton onClick={handleRefresh} size="small">
							<RefreshIcon />
						</IconButton>
					</Tooltip>
					<Button
						variant="text"
						size="small"
						startIcon={<AddIcon />}
						onClick={() => setUploadDialogOpen(true)}
					>
						Nahrát soubor
					</Button>
				</Stack>
			</Stack>

			<Box sx={{ display: "flex", height: "calc(100% - 52px)" }}>
				<FolderTree
					files={files}
					selectedFolder={selectedFolder}
					onFolderSelect={setSelectedFolder}
					isLoading={isLoading}
				/>
				<FileList
					files={files}
					selectedFolder={selectedFolder}
					onViewVersionHistory={setVersionHistoryFile}
					isLoading={isLoading}
				/>
			</Box>

			{versionHistoryFile && (
				<FileVersionHistory
					file={versionHistoryFile}
					open={!!versionHistoryFile}
					onClose={() => setVersionHistoryFile(null)}
				/>
			)}

			<FileUploadDialog
				open={uploadDialogOpen}
				onClose={() => setUploadDialogOpen(false)}
				defaultFolderPath={selectedFolder}
			/>
		</Box>
	);
};
